.wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.wrap .amount {
  width: 4.5em;
  flex: 0 0 auto;
}

.toggle {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0 4px;
  color: #808080;
}
.toggle:hover {
  color: inherit;
}

:global(.dark) .toggle {
  color: #909090;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFtb3VudFJhbmdlRmllbGQuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTs7QUFJQTtFQUNFO0VBQ0E7OztBQUVKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOzs7QUFFSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLndyYXBcbiAgZGlzcGxheTogaW5saW5lLWZsZXhcbiAgYWxpZ24taXRlbXM6IGNlbnRlclxuICBnYXA6IDRweFxuXG4gIC8vIEFtb3VudHMgYXJlIHNob3J0IG51bWJlcnM6IGRvbid0IGxldCB0aGUgaW5wdXRzIGNsYWltXG4gIC8vIGFsbCB0aGUgd2lkdGggdGhleSBjYW5cbiAgLmFtb3VudFxuICAgIHdpZHRoOiA0LjVlbVxuICAgIGZsZXg6IDAgMCBhdXRvXG5cbi50b2dnbGVcbiAgYm9yZGVyOiBub25lXG4gIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50XG4gIGN1cnNvcjogcG9pbnRlclxuICBwYWRkaW5nOiAwIDRweFxuICBjb2xvcjogIzgwODA4MFxuICAmOmhvdmVyXG4gICAgY29sb3I6IGluaGVyaXRcblxuOmdsb2JhbCguZGFyaykgLnRvZ2dsZVxuICBjb2xvcjogIzkwOTA5MFxuIl19 */